export default __webpack_public_path__ + "static/media/jezowka_cien.bf090d2f.svg";